var $3b4c1ba5afd57b35$exports = {};
$3b4c1ba5afd57b35$exports = {
    "dropzoneLabel": `Zon\u{103} de plasare`,
    "selectPlaceholder": `Selecta\u{21B}i un element`,
    "tableResizer": `Instrument de redimensionare`,
    "colorSwatchPicker": `Color swatches`
};


export {$3b4c1ba5afd57b35$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
